module.exports = __webpack_public_path__ + "img/system-collapse.a6994bd4.png";